import RestAPI from '../Common/restApi';

export default class InvoiceSettingsApi {
  static show(requestId) {
    return RestAPI.get(`/api/v2/pro/requests/${requestId}/invoice_settings`);
  }

  static update(params) {
    return RestAPI.updateWithFormData(`/api/v2/pro/requests/invoice_settings`, params);
  }

  static acceptACH() {
    return RestAPI.updateWithFormData('/api/v2/pro/requests/invoice_settings/accept_ach', {});
  }
}
